/* eslint  react/jsx-no-bind:0 */
import React from "react"
import { Route } from "react-router-dom"
import Dashboard from "../../containers/dashboard"
import EventsView from "../../containers/eventsview"
import EventPage from '../../containers/event'
import PostEventPage from '../../containers/postevent'
/*import EventResult from "../pages/EventResult"
import Statistics from "../pages/Statistics"  */
//import Register from "../pages/RegistrationInvitation"
import UserManagement from "../../containers/userManagement"
import UpcomingEvent from "../../containers/event/upcomingevent"
import SeasonSettings from "../../containers/season"
import Reports from "../../containers/reports"
import ManageAdvancers from "../../containers/postevent/components/manageAdvancers"
import OrphanedEvents from '../../containers/postevent/components/orphaned'
import Deposits from '../../containers/deposit'
import Base from "./Base"
import ModalRoot from "./ModalRoot"

const IndexPage = () => (
 
  <Base>
    <Route path="/dashboard" component={Dashboard} /> 
    <Route exact path="/event" component={EventPage} />
    <Route exact path="/events/:id" component={EventPage} /> 
    <Route exact path="/postevent" component={PostEventPage} />
    <Route exact path="/viewevents" component={EventsView} />
    {/*<Route path="/results" component={EventResult} />
    <Route path="/reports" component={Reports} />
    <Route path="/statistics" component={Statistics} /> */}
    <Route path="/usermanagement" component={UserManagement} /> 
    <Route path="/usermanagement/:status" component={UserManagement} /> 
    <Route path="/upcomingevents" component={UpcomingEvent} />
    <Route path="/seasonsettings" component={SeasonSettings} />
    <Route path="/reports" component={Reports} />
    <Route path="/manageadvancers" component={ManageAdvancers} />
    <Route path="/orphanedevents" component={OrphanedEvents} />
    <Route path="/managedeposits" component={Deposits}/>
    <ModalRoot />
  </Base>
)
export default IndexPage


// WEBPACK FOOTER //
// ./src/components/layout/IndexPage.js